export type SurveySegment = "subscriber" | "member" | "activeCreator" | "lapsedCreator"
export type SurveyChannel = "popup" | "bell" | "email"

export const SURVEY_CHANNELS: SurveyChannel[] = ["popup", "bell", "email"]
export const SURVEY_CREDIT_PACKAGE_TAG = "survey-credit"

// Every entry point goes through our redirect, which records the open and hands the user's token to the survey.
export const surveyOpenPath = (via: SurveyChannel) => `/s/open?via=${via}`

export const isSurveyLogin = (redirectTo: string | null) => !!redirectTo?.startsWith("/s/open")

export type PromptCopy = { title: string; body: string; creditDetail: string; duration: string }

const FALLBACK_PROMPT: PromptCopy = {
  title: "We'd love your feedback",
  body: "Tell us how MakeLoveNotPorn has been for you and what we could do better. Your answers will shape what we build next.",
  creditDetail: "Complete the survey and we'll add it to your account. Rent any video you like.",
  duration: "Takes about 9 minutes",
}

const PROMPTS: Partial<Record<SurveySegment, PromptCopy>> = {
  subscriber: {
    title: "Help shape what we build next",
    body: "You know MakeLoveNotPorn better than anyone. Tell us what you love and what we could do better, and your answers will shape the next version of MLNP.",
    creditDetail: "Complete the survey and we'll add it to your account. Rent any video you like.",
    duration: "Takes about 8 minutes",
  },
  member: {
    title: "A free video, on us",
    body: "We'd love to know what brought you to MakeLoveNotPorn and what would make it worth it for you. Share a few thoughts, and your answers will shape what we build next.",
    creditDetail: "Complete the survey and rent any real world sex video, free.",
    duration: "Takes about 8 minutes",
  },
  activeCreator: {
    title: "Help shape MLNP for MLNPstars",
    body: "You know what it's really like to share on MakeLoveNotPorn. Tell us what's working and what we could do better, and your answers will shape what we build for MLNPstars next.",
    creditDetail: "Complete the survey and we'll add it to your account. Use it to rent any video you like.",
    duration: "Takes about 11 minutes",
  },
}

export const promptCopy = (segment: SurveySegment) => PROMPTS[segment] ?? FALLBACK_PROMPT

const NOTIFICATIONS: Record<SurveySegment, { Title: string; Description: string }> = {
  subscriber: {
    Title: "Help shape what we build next",
    Description: "Take a short survey about MLNP and get 1 free credit.",
  },
  member: {
    Title: "A free video, on us",
    Description: "Share a few thoughts in a short survey and get 1 free credit.",
  },
  activeCreator: {
    Title: "Help shape MLNP for MLNPstars",
    Description: "Tell us what's working for you as a creator and get 1 free credit.",
  },
  lapsedCreator: {
    Title: "We'd love your feedback",
    Description: "Take a short survey about MLNP and get 1 free credit.",
  },
}

export const surveyNotification = (segment: SurveySegment) => ({
  Kind: "survey" as const,
  ...NOTIFICATIONS[segment],
  ActionLink: surveyOpenPath("bell"),
  ActionText: "Take the survey",
})

// How long the "your free credit is here" card stays in the bell after the credit is granted.
export const SURVEY_CREDIT_NOTIFICATION_DAYS = 7

export const surveyCreditNotification = () => ({
  Kind: "surveyCredit" as const,
  Title: "Your free credit is here!",
  Description: "Thanks for taking the survey. Pick any video you like, on us.",
  ActionLink: "/videos",
  ActionText: "Find a video",
})
